import {
  ADD_NEW_CHAT_TOPIC,
  ADD_NEW_GROUP,
  ADD_NEW_MESSAGE,
  ADD_NEW_MESSAGE_IN_CHAT,
  ADD_NEW_MESSAGE_SLOW,
  ADD_NEW_PERSONAL_GROUP,
  ADD_NEW_SYSTEM_MESSAGE,
  ADD_THINKING_MESSAGE,
  CHANGE_STATUS_CHAT,
  CHECK_CHAT_IN_TRACK_SUCCESS,
  CHECK_NEW_MESSAGE_SUCCESS,
  CLEANUP_PENDING_REPLACEMENTS,
  CLEAR_FOUND_GROUPS,
  CLEAR_GROUPS,
  CLEAR_MESSAGES,
  CLEAR_PERSONAL_GROUPS,
  CLEAR_REPLY_MESSAGE,
  CLEAR_SEARCH_USERS,
  CLEAR_SELECTED_BOT,
  CLEAR_SELECTED_CHAT_TOPIC,
  CLEAR_SELECTED_USER,
  CLEAR_THINKING_MESSAGES,
  CLEAR_USERS,
  CREATE_BREAKOUT_REPORT_FAIL,
  CREATE_BREAKOUT_REPORT_START,
  CREATE_BREAKOUT_REPORT_SUCCESS,
  CREATE_MINI_GROUP_FAIL,
  CREATE_MINI_GROUP_START,
  CREATE_MINI_GROUP_SUCCESS,
  DELETE_CHAT_GROUP,
  DELETE_CHAT_GROUP_USER_SUCCESS,
  DELETE_MINI_GROUP_FAIL,
  DELETE_MINI_GROUP_START,
  DELETE_MINI_GROUP_SUCCESS,
  GET_AVAILABLE_TOOLS_FAIL,
  GET_AVAILABLE_TOOLS_START,
  GET_AVAILABLE_TOOLS_SUCCESS,
  GET_BOT_SYSTEM_PROMPT_FAIL,
  GET_BOT_SYSTEM_PROMPT_START,
  GET_BOT_SYSTEM_PROMPT_SUCCESS,
  GET_BOT_TEMPERATURE_FAIL,
  GET_BOT_TEMPERATURE_START,
  GET_BOT_TEMPERATURE_SUCCESS,
  GET_BOT_TOOLS_FAIL,
  GET_BOT_TOOLS_START,
  GET_BOT_TOOLS_SUCCESS,
  GET_BOTS_LIST_FAIL,
  GET_BOTS_LIST_START,
  GET_BOTS_LIST_SUCCESS,
  GET_BREAKOUT_REPORT_FAIL,
  GET_BREAKOUT_REPORT_START,
  GET_BREAKOUT_REPORT_SUCCESS,
  GET_CHAT_BOTS_SUCCESS,
  GET_CHAT_TOPICS_SUCCESS,
  GET_CHATS_START,
  GET_CHATS_SUCCESS,
  GET_COMPANY_TOKEN_QUOTA_FAIL,
  // Token usage constants
  GET_COMPANY_TOKEN_QUOTA_START,
  GET_COMPANY_TOKEN_QUOTA_SUCCESS,
  GET_COMPANY_TOKEN_USAGE_FAIL,
  GET_COMPANY_TOKEN_USAGE_START,
  GET_COMPANY_TOKEN_USAGE_SUCCESS,
  GET_CURRENT_USER_GROUP_ID_FAIL,
  GET_CURRENT_USER_GROUP_ID_START,
  GET_CURRENT_USER_GROUP_ID_SUCCESS,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_PAGINATED_FAIL,
  GET_MESSAGES_PAGINATED_START,
  GET_MESSAGES_PAGINATED_SUCCESS,
  GET_MESSAGES_START,
  GET_MESSAGES_SUCCESS,
  GET_MINI_GROUP_FAIL,
  GET_MINI_GROUP_START,
  GET_MINI_GROUP_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_IN_CHAT_START,
  GET_USERS_IN_CHAT_SUCCESS,
  GET_USERS_START,
  GET_USERS_SUCCESS,
  LOAD_MORE_MESSAGES_FAIL,
  LOAD_MORE_MESSAGES_START,
  LOAD_MORE_MESSAGES_SUCCESS,
  NEW_CHAT_BOT,
  PUSH_COMPANY_TOKEN_QUOTA_FAIL,
  PUSH_COMPANY_TOKEN_QUOTA_START,
  PUSH_COMPANY_TOKEN_QUOTA_SUCCESS,
  READ_MESSAGES_IN_CHAT,
  REPLACE_THINKING_MESSAGE,
  SEARCH_GROUPS,
  SEARCH_USERS_FAIL,
  SEARCH_USERS_START,
  SEARCH_USERS_SUCCESS,
  SET_REPLY_MESSAGE,
  SET_SELECTED_BOT,
  SET_SELECTED_CHAT_TOPIC,
  SET_SELECTED_USER,
  STOP_SWITCHING_LOADING,
  UPDATE_BOT_SYSTEM_PROMPT_FAIL,
  UPDATE_BOT_SYSTEM_PROMPT_START,
  UPDATE_BOT_SYSTEM_PROMPT_SUCCESS,
  UPDATE_BOT_TEMPERATURE_FAIL,
  UPDATE_BOT_TEMPERATURE_START,
  UPDATE_BOT_TEMPERATURE_SUCCESS,
  UPDATE_BOT_TOOLS_FAIL,
  UPDATE_BOT_TOOLS_START,
  UPDATE_BOT_TOOLS_SUCCESS,
  UPDATE_BREAKOUT_REPORT_FAIL,
  UPDATE_BREAKOUT_REPORT_START,
  UPDATE_BREAKOUT_REPORT_SUCCESS,
  UPDATE_CHAT_GROUP,
  UPDATE_CHAT_GROUP_USERS_START,
  UPDATE_CHAT_GROUP_USERS_SUCCESS,
  UPDATE_COMPANY_TOKEN_QUOTA,
  UPDATE_MINI_GROUP_FAIL,
  UPDATE_MINI_GROUP_START,
  UPDATE_MINI_GROUP_SUCCESS,
} from './constants';

const initialState = {
  selectedUser: null,
  selectedChatTopic: null,
  replyMessage: null,
  countNewMessage: 0,
  currentUserGroupId: null,
  users: [],
  messages: [],
  hasMoreMessages: true, // Whether there are more messages to load
  currentPage: 0, // Current page for pagination
  isLoadingMessages: false, // Loading state for pagination
  isSwitchingChat: false, // Loading state for chat switching
  pendingReplacements: new Map(), // Tracking pending thinking message replacements
  foundUsers: [],
  groups: [],
  foundGroups: [],
  chatUsers: [],
  chatMiniGroups: [],
  chatTopics: [],
  chatBots: [],
  breakoutReports: [],
  trackChatId: null,
  // Thinking messages state
  thinkingMessages: new Map(), // Map<messageId, messageData>
  // Bot list and selection state
  botsList: [],
  selectedBot: null,
  // Bot settings state
  botSettings: {
    systemPrompt: '',
    tools: {}, // toolsDescriptions object
    availableTools: [], // array of available tools
    temperature: 0.7, // bot temperature setting
  },
  // Token usage state
  tokenQuota: {
    company_id: null,
    global_limit: 0,
    global_used: 0,
    global_cost: 0,
    last_updated: null,
  },
  tokenUsage: {
    items: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 20,
    },
  },
  isLoading: {
    searchUsers: false,
    getGroups: false,
    getUsers: false,
    getChats: false,
    getBreakoutReports: false,
    // Bot settings loading states
    getBotSystemPrompt: false,
    updateBotSystemPrompt: false,
    getBotTools: false,
    updateBotTools: false,
    getAvailableTools: false,
    getBotTemperature: false,
    updateBotTemperature: false,
    // Bot list loading states
    getBotsList: false,
    getBotDetailedInstructions: false,
    // Token usage loading states
    getCompanyTokenQuota: false,
    getCompanyTokenUsage: false,
    pushCompanyTokenQuota: false,
  },
  isError: {
    searchUsers: false,
    getGroups: false,
    getUsers: false,
    // Bot settings error states
    getBotSystemPrompt: false,
    updateBotSystemPrompt: false,
    getBotTools: false,
    updateBotTools: false,
    getAvailableTools: false,
    getBotTemperature: false,
    updateBotTemperature: false,
    // Bot list error states
    getBotsList: false,
    // Token usage error states
    getCompanyTokenQuota: false,
    getCompanyTokenUsage: false,
    pushCompanyTokenQuota: false,
  },
  pagination: {
    getUsers: {
      size: 0,
      totalElements: 0,
      page: 0,
    },
    getChatUsers: {
      size: 0,
      totalElements: 0,
      page: 0,
    },
  },
};

const findGroup = (groupId, groups) => {
  const groupIndex = groups.findIndex(group => group?.chatId === groupId || group?.chatId === groupId);
  return groupIndex;
};

export default (state = initialState, { type, response, headers, action, data }) => {
  const newGroupsList = state.groups;
  const newChatTopicList = state.chatTopics;
  let groupIndex = null;
  let newChat = null;
  let chatTopicIndex = null;

  switch (type) {
    case GET_USERS_START:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          getUsers: true,
        },
        isError: {
          ...state.isError,
          getUsers: false,
        },
      };

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: [...state.users, ...response],
        isLoading: {
          ...state.isLoading,
          getUsers: false,
        },
        isError: {
          ...state.isError,
          getUsers: false,
        },
        pagination: {
          ...state.pagination,
          getUsers: {
            size: Number(headers.get('X-Page-Size')) || 0,
            totalElements: Number(headers.get('X-Total-Elements')) || 0,
            page: Number(headers.get('X-Page-Number')) || 0,
          },
        },
      };

    case GET_USERS_FAIL:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          getUsers: false,
        },
        isError: {
          ...state.isError,
          getUsers: true,
        },
        users: [],
      };

    case SET_SELECTED_USER:
      if (data.chatId && !data?.isMentoring) {
        groupIndex = findGroup(data.chatId, newGroupsList);

        if (!data.hasTopic) {
          state.countNewMessage -= newGroupsList[groupIndex]?.notReadMessages;
        }
      }

      if (
        data.chatId &&
        !data.hasTopic &&
        !data?.isMentoring &&
        groupIndex !== -1 &&
        newGroupsList[groupIndex]?.notReadMessages
      ) {
        newGroupsList[groupIndex].notReadMessages = 0;
      }

      return {
        ...state,
        selectedUser: data,
        foundUsers: [],
        chatMiniGroups: [],
      };

    case SET_SELECTED_CHAT_TOPIC:
      if (data.chatId && !data?.isMentoring) {
        chatTopicIndex = findGroup(data.chatId, newChatTopicList);
        groupIndex = findGroup(state.selectedUser.chatId, newGroupsList);
        state.countNewMessage -= newChatTopicList[chatTopicIndex].notReadMessages;
      }

      if (groupIndex !== -1 && newGroupsList[groupIndex].notReadMessages) {
        newGroupsList[groupIndex].notReadMessages -= newChatTopicList[chatTopicIndex].notReadMessages;
      }

      if (
        data.chatId &&
        !data?.isMentoring &&
        chatTopicIndex !== -1 &&
        newChatTopicList[chatTopicIndex].notReadMessages
      ) {
        newChatTopicList[chatTopicIndex].notReadMessages = 0;
      }

      return {
        ...state,
        selectedChatTopic: data,
      };

    case SEARCH_USERS_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, searchUsers: true },
        isError: { ...state.isError, searchUsers: false },
        foundUsers: state.foundUsers,
      };

    case SEARCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, searchUsers: false },
        isError: { ...state.isError, searchUsers: false },
        foundUsers: action.isClear ? response : [...state.foundUsers, ...response],
      };

    case SEARCH_USERS_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, searchUsers: false },
        isError: { ...state.isError, searchUsers: true },
        foundUsers: state.foundUsers,
      };

    case GET_CHATS_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getChats: true },
      };

    case GET_MESSAGES_START:
    case GET_MESSAGES_FAIL:
      return state;

    case GET_CHATS_SUCCESS:
      return {
        ...state,
        groups: response.page === 1 ? response.items : [...state.groups, ...response.items],
        isLoading: { ...state.isLoading, getChats: false },
        pagination: {
          ...state.pagination,
          getChats: {
            size: response.limit,
            totalElements: response.total,
            page: response.page,
          },
        },
      };

    case GET_MESSAGES_SUCCESS:
      // Сохраняем думающие сообщения при загрузке новых сообщений
      const existingThinkingMessages = state.messages.filter(msg => msg.messageData.isThinking);
      console.log('💾 Preserving thinking messages:', existingThinkingMessages);

      // Проверяем, есть ли новая структура с pagination или старая структура (массив)
      const messagesArray = Array.isArray(response) ? response : response?.messages || [];
      console.log('📦 GET_MESSAGES_SUCCESS: Received messages:', messagesArray.length);

      return {
        ...state,
        messages: [...messagesArray, ...existingThinkingMessages],
        isSwitchingChat: false, // Reset chat switching state
      };

    case GET_MESSAGES_PAGINATED_SUCCESS:
      // Initial load of messages with pagination
      const existingThinkingMessagesPaginated = state.messages.filter(msg => msg.messageData.isThinking);

      // Извлекаем массив сообщений и информацию о пагинации
      const paginatedMessages = response?.messages || [];
      const paginationInfo = response?.pagination || {};

      console.log('📄 GET_MESSAGES_PAGINATED_SUCCESS: Loading initial messages:', paginatedMessages.length);
      console.log('📄 Pagination info:', paginationInfo);

      return {
        ...state,
        messages: [...paginatedMessages, ...existingThinkingMessagesPaginated],
        hasMoreMessages: paginationInfo.hasNext || false,
        currentPage: paginationInfo.page || 0,
        isLoadingMessages: false,
        isSwitchingChat: false, // Reset chat switching state
      };

    case LOAD_MORE_MESSAGES_SUCCESS:
      // Append older messages to the END of the list (because of column-reverse CSS)
      const moreMessages = response?.messages || [];
      const morePaginationInfo = response?.pagination || {};

      console.log('📄 LOAD_MORE_MESSAGES_SUCCESS: Loading more messages:', moreMessages.length);
      console.log('📄 More pagination info:', morePaginationInfo);

      return {
        ...state,
        messages: [...state.messages, ...moreMessages], // Append older messages to END (for column-reverse)
        hasMoreMessages: morePaginationInfo.hasNext || false,
        currentPage: morePaginationInfo.page || (state.currentPage || 0) + 1,
        isLoadingMessages: false,
      };

    case GET_MESSAGES_PAGINATED_START:
    case LOAD_MORE_MESSAGES_START:
      return {
        ...state,
        isLoadingMessages: true,
      };

    case GET_MESSAGES_PAGINATED_FAIL:
    case LOAD_MORE_MESSAGES_FAIL:
      console.warn('📄 Paginated messages API failed, might need fallback');
      return {
        ...state,
        isLoadingMessages: false,
        isSwitchingChat: false, // Reset chat switching state on error
      };

    case CLEAR_SEARCH_USERS:
      return { ...state, foundUsers: [] };

    case ADD_NEW_MESSAGE_SLOW:
      return { ...state, messages: [data, ...state.messages] };

    case ADD_NEW_MESSAGE_IN_CHAT:
      if (state.selectedChatTopic) {
        groupIndex = findGroup(data.messageData.chatId, newChatTopicList);

        newChat = newChatTopicList[groupIndex];
        newChat.lastMessage = data.messageData;
        newChatTopicList.splice(groupIndex, 1);
        newChatTopicList.unshift(newChat);

        return {
          ...state,
          messages: [data, ...state.messages],
          chatTopics: newChatTopicList,
        };
      } else {
        // groupIndex = findGroup(data.messageData.chatId, newGroupsList);

        // newChat = newGroupsList[groupIndex];
        // newChat.lastMessage = data.messageData;
        // newGroupsList.splice(groupIndex, 1);
        // newGroupsList.unshift(newChat);

        return {
          ...state,
          messages: [data, ...state.messages],
          // groups: newGroupsList,
        };
      }

    case ADD_NEW_PERSONAL_GROUP:
      return {
        ...state,
        groups: [{ ...data, notReadMessages: 1 }, ...state.groups],
        countNewMessage: state.countNewMessage + 1,
      };

    case ADD_NEW_GROUP:
      return {
        ...state,
        groups: [data, ...state.groups],
      };

    case CLEAR_MESSAGES:
      // Полностью очищаем все сообщения при переключении чатов
      console.log('🧹 Clearing all messages (including thinking messages from previous chat)');

      return {
        ...state,
        messages: [],
        hasMoreMessages: true, // Reset pagination state
        currentPage: 0,
        isLoadingMessages: false,
        isSwitchingChat: true, // Indicate chat switching
        // Добавляем флаг для синхронизации менеджера
        needsManagerSync: true,
        // Очищаем ожидающие замены
        pendingReplacements: new Map(),
      };

    case CLEAR_SELECTED_USER:
      return { ...state, selectedUser: null };

    case CLEAR_SELECTED_CHAT_TOPIC:
      return { ...state, selectedChatTopic: null };

    case READ_MESSAGES_IN_CHAT:
      groupIndex = findGroup(data.chatId, newGroupsList);
      if (groupIndex !== -1) {
        newGroupsList[groupIndex].lastMessage.isRead = true;
      }
      return { ...state, groups: newGroupsList };

    case ADD_NEW_MESSAGE:
      groupIndex = findGroup(data.parentChatId ?? data.messageData.chatId, newGroupsList);
      chatTopicIndex = findGroup(data.messageData.chatId, newChatTopicList);

      if (groupIndex !== -1) {
        newChat = newGroupsList[groupIndex];
        newChat.lastMessage = data.messageData;
        newChat.notReadMessages += 1;
        newGroupsList.splice(groupIndex, 1);
        newGroupsList.unshift(newChat);
      }

      if (chatTopicIndex !== -1) {
        newChat = newChatTopicList[chatTopicIndex];
        newChat.lastMessage = data.messageData;
        newChat.notReadMessages += 1;
        newChatTopicList.splice(chatTopicIndex, 1);
        newChatTopicList.unshift(newChat);
      }

      return {
        ...state,
        countNewMessage: data?.requestId ? state.countNewMessage : state.countNewMessage + 1,
        groups: newGroupsList,
        chatTopics: newChatTopicList,
      };

    case CHECK_NEW_MESSAGE_SUCCESS:
      return { ...state, countNewMessage: response?.count };

    case SET_REPLY_MESSAGE:
      return { ...state, replyMessage: data };

    case CLEAR_REPLY_MESSAGE:
      return { ...state, replyMessage: null };

    case CLEAR_GROUPS:
      return { ...state, groups: [] };

    case UPDATE_CHAT_GROUP_USERS_START:
    case GET_USERS_IN_CHAT_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getChatUsers: true },
      };

    case UPDATE_CHAT_GROUP_USERS_SUCCESS:
      return {
        ...state,
        chatUsers: response.items,
        isLoading: {
          ...state.isLoading,
          getChatUsers: false,
        },
        pagination: {
          ...state.pagination,
          getChatUsers: {
            size: response.limit,
            totalElements: response.total,
            page: response.page,
          },
        },
      };

    case GET_USERS_IN_CHAT_SUCCESS:
      return {
        ...state,
        chatUsers: response.page === 1 ? response.items : [...state.chatUsers, ...response.items],
        isLoading: {
          ...state.isLoading,
          getChatUsers: false,
        },
        pagination: {
          ...state.pagination,
          getChatUsers: {
            size: response.limit,
            totalElements: response.total,
            page: response.page,
          },
        },
      };

    case CLEAR_USERS:
      return { ...state, users: [] };

    case SEARCH_GROUPS:
      return {
        ...state,
        foundGroups: state.groups.filter(group => group?.chatName?.toLowerCase()?.includes(data.toLowerCase())),
      };

    case CLEAR_FOUND_GROUPS:
      return { ...state, foundGroups: [] };

    case CLEAR_PERSONAL_GROUPS:
      return { ...state, chatUsers: [] };

    case DELETE_CHAT_GROUP:
      if (state.selectedUser?.chatId === data?.chatId) {
        return {
          ...state,
          selectedUser: null,
          groups: state.groups.filter(group => group?.chatId !== data?.chatId),
        };
      }
      if (state.selectedChatTopic?.chatId === data?.chatId) {
        return {
          ...state,
          selectedChatTopic: null,
          chatTopics: state.chatTopics.filter(topic => topic?.chatId !== data?.chatId),
        };
      } else {
        return {
          ...state,
          groups: state.groups.filter(group => group?.chatId !== data?.chatId),
          chatTopics: state.chatTopics.filter(topic => topic?.chatId !== data?.chatId),
        };
      }

    case DELETE_CHAT_GROUP_USER_SUCCESS:
      return {
        ...state,
        chatUsers: state.chatUsers.filter(user => user.id !== response.userId),
      };

    case GET_CHAT_TOPICS_SUCCESS:
      return {
        ...state,
        chatTopics: response,
      };

    case UPDATE_CHAT_GROUP:
      groupIndex = findGroup(data.chatId, newGroupsList);
      chatTopicIndex = findGroup(data.chatId, newChatTopicList);

      if (groupIndex !== -1) {
        newGroupsList[groupIndex] = { ...newGroupsList[groupIndex], ...data };
      }
      if (chatTopicIndex !== -1) {
        newChatTopicList[chatTopicIndex] = { ...newChatTopicList[chatTopicIndex], ...data };
      }

      const newSelectedUser =
        state.selectedUser?.chatId === data.chatId
          ? { ...state.selectedUser, chatName: data.chatName, photo: data.chatPhotoUuid }
          : state.selectedUser;

      const newSelectedChatTopic =
        state.selectedChatTopic?.chatId === data.chatId
          ? { ...state.selectedChatTopic, chatName: data.chatName, withBreakout: data.withBreakout }
          : state.selectedChatTopic;

      return {
        ...state,
        groups: newGroupsList,
        chatTopics: newChatTopicList,
        selectedUser: newSelectedUser,
        selectedChatTopic: newSelectedChatTopic,
      };

    case ADD_NEW_CHAT_TOPIC:
      return { ...state, chatTopics: [...state.chatTopics, data] };

    case CHANGE_STATUS_CHAT:
      const chatIndex = state.groups.findIndex(group => group.chatId === state.selectedUser.chatId);

      if (chatIndex !== -1) {
        state.groups[chatIndex].hasTopic = !state.selectedUser.hasTopic;
      }

      return { ...state, selectedUser: { ...state.selectedUser, hasTopic: !state.selectedUser.hasTopic } };

    case CHECK_CHAT_IN_TRACK_SUCCESS:
      return { ...state, trackChatId: response };

    case GET_MINI_GROUP_SUCCESS:
      return { ...state, chatMiniGroups: response };

    case GET_BREAKOUT_REPORT_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBreakoutReports: true },
        breakoutReports: [],
      };

    case GET_BREAKOUT_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBreakoutReports: false },
        breakoutReports: response,
      };

    case GET_BREAKOUT_REPORT_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBreakoutReports: false },
        breakoutReports: [],
      };

    case CREATE_BREAKOUT_REPORT_SUCCESS:
      return {
        ...state,
        breakoutReports: [...state.breakoutReports, response],
      };

    case ADD_NEW_SYSTEM_MESSAGE:
      return {
        ...state,
        messages: [data, ...state.messages],
      };

    case GET_CURRENT_USER_GROUP_ID_SUCCESS:
      return {
        ...state,
        currentUserGroupId: response?.data === '' ? null : response,
      };

    case GET_CHAT_BOTS_SUCCESS:
      return {
        ...state,
        chatBots: response,
      };

    case NEW_CHAT_BOT:
      return {
        ...state,
        selectedUser: data.bot?.botId === state.selectedUser?.botId ? data : state.selectedUser,
        chatBots: [...state.chatBots, data],
      };

    // Bot List handlers
    case GET_BOTS_LIST_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotsList: true },
        isError: { ...state.isError, getBotsList: false },
      };

    case GET_BOTS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotsList: false },
        isError: { ...state.isError, getBotsList: false },
        botsList: response || [],
      };

    case GET_BOTS_LIST_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotsList: false },
        isError: { ...state.isError, getBotsList: true },
        botsList: [],
      };

    // Selected Bot handlers
    case SET_SELECTED_BOT:
      return {
        ...state,
        selectedBot: data,
      };

    case CLEAR_SELECTED_BOT:
      return {
        ...state,
        selectedBot: null,
      };

    // Bot System Prompt handlers
    case GET_BOT_SYSTEM_PROMPT_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotSystemPrompt: true },
        isError: { ...state.isError, getBotSystemPrompt: false },
      };

    case GET_BOT_SYSTEM_PROMPT_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotSystemPrompt: false },
        isError: { ...state.isError, getBotSystemPrompt: false },
        botSettings: {
          ...state.botSettings,
          systemPrompt: response?.systemPrompt || '',
        },
      };

    case GET_BOT_SYSTEM_PROMPT_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotSystemPrompt: false },
        isError: { ...state.isError, getBotSystemPrompt: true },
      };

    case UPDATE_BOT_SYSTEM_PROMPT_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotSystemPrompt: true },
        isError: { ...state.isError, updateBotSystemPrompt: false },
      };

    case UPDATE_BOT_SYSTEM_PROMPT_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotSystemPrompt: false },
        isError: { ...state.isError, updateBotSystemPrompt: false },
        botSettings: {
          ...state.botSettings,
          systemPrompt: response?.systemPrompt || state.botSettings.systemPrompt,
        },
      };

    case UPDATE_BOT_SYSTEM_PROMPT_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotSystemPrompt: false },
        isError: { ...state.isError, updateBotSystemPrompt: true },
      };

    // Bot Tools handlers
    case GET_BOT_TOOLS_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTools: true },
        isError: { ...state.isError, getBotTools: false },
      };

    case GET_BOT_TOOLS_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTools: false },
        isError: { ...state.isError, getBotTools: false },
        botSettings: {
          ...state.botSettings,
          tools: response?.toolsDescriptions || {},
        },
      };

    case GET_BOT_TOOLS_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTools: false },
        isError: { ...state.isError, getBotTools: true },
      };

    case UPDATE_BOT_TOOLS_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTools: true },
        isError: { ...state.isError, updateBotTools: false },
      };

    case UPDATE_BOT_TOOLS_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTools: false },
        isError: { ...state.isError, updateBotTools: false },
        botSettings: {
          ...state.botSettings,
          tools: response?.toolsDescriptions || state.botSettings.tools,
        },
      };

    case UPDATE_BOT_TOOLS_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTools: false },
        isError: { ...state.isError, updateBotTools: true },
      };

    // Available Tools handlers
    case GET_AVAILABLE_TOOLS_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getAvailableTools: true },
        isError: { ...state.isError, getAvailableTools: false },
      };

    case GET_AVAILABLE_TOOLS_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getAvailableTools: false },
        isError: { ...state.isError, getAvailableTools: false },
        botSettings: {
          ...state.botSettings,
          availableTools: response || [],
        },
      };

    case GET_AVAILABLE_TOOLS_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getAvailableTools: false },
        isError: { ...state.isError, getAvailableTools: true },
      };

    // Bot Temperature handlers
    case GET_BOT_TEMPERATURE_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTemperature: true },
        isError: { ...state.isError, getBotTemperature: false },
      };

    case GET_BOT_TEMPERATURE_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTemperature: false },
        isError: { ...state.isError, getBotTemperature: false },
        botSettings: {
          ...state.botSettings,
          temperature: response?.temperature ?? state.botSettings.temperature,
        },
      };

    case GET_BOT_TEMPERATURE_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getBotTemperature: false },
        isError: { ...state.isError, getBotTemperature: true },
      };

    case UPDATE_BOT_TEMPERATURE_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTemperature: true },
        isError: { ...state.isError, updateBotTemperature: false },
      };

    case UPDATE_BOT_TEMPERATURE_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTemperature: false },
        isError: { ...state.isError, updateBotTemperature: false },
        botSettings: {
          ...state.botSettings,
          temperature: response?.temperature ?? state.botSettings.temperature,
        },
      };

    case UPDATE_BOT_TEMPERATURE_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, updateBotTemperature: false },
        isError: { ...state.isError, updateBotTemperature: true },
      };

    case GET_CURRENT_USER_GROUP_ID_START:
    case GET_CURRENT_USER_GROUP_ID_FAIL:
    case UPDATE_BREAKOUT_REPORT_START:
    case UPDATE_BREAKOUT_REPORT_SUCCESS:
    case UPDATE_BREAKOUT_REPORT_FAIL:
    case CREATE_BREAKOUT_REPORT_START:
    case CREATE_BREAKOUT_REPORT_FAIL:
    case GET_MINI_GROUP_START:
    case GET_MINI_GROUP_FAIL:
    case UPDATE_MINI_GROUP_START:
    case UPDATE_MINI_GROUP_SUCCESS:
    case UPDATE_MINI_GROUP_FAIL:
    case CREATE_MINI_GROUP_START:
    case CREATE_MINI_GROUP_SUCCESS:
    case CREATE_MINI_GROUP_FAIL:
    case DELETE_MINI_GROUP_START:
    case DELETE_MINI_GROUP_SUCCESS:
    case DELETE_MINI_GROUP_FAIL:
      return state;

    // Thinking messages cases
    case ADD_THINKING_MESSAGE:
      console.log('🔍 ADD_THINKING_MESSAGE reducer called with data:', data);

      // Проверяем корректность данных
      if (!data || !data.messageData || !data.messageData.messageId) {
        console.error('❌ Invalid thinking message data:', data);
        return state;
      }

      // Check if thinking message already exists to avoid duplicates
      const existingThinkingMessage = state.messages.find(
        msg => msg.messageData.messageId === data.messageData.messageId
      );

      if (existingThinkingMessage) {
        console.log('⚠️ Thinking message already exists, skipping:', data.messageData.messageId);
        return state;
      }

      // Проверяем, есть ли ожидающая замена для этого сообщения
      const pendingReplacement = state.pendingReplacements?.get?.(data.messageData.messageId);
      if (pendingReplacement) {
        console.log('🔄 Found pending replacement, applying immediately:', pendingReplacement);

        // Создаем финальное сообщение вместо thinking
        const finalMessage = {
          messageData: {
            ...pendingReplacement.newMessage,
            messageId: pendingReplacement.newMessage.messageId || data.messageData.messageId,
            isThinking: false,
            isBot: true,
            isError: pendingReplacement.newMessage.isError || false,
            createdAt:
              pendingReplacement.newMessage.timestamp ||
              pendingReplacement.newMessage.createdAt ||
              new Date().toISOString(),
          },
          userData: {
            firstName: pendingReplacement.newMessage.botName || 'Бот',
            lastName: '',
            localPhotoUuid: null,
          },
        };

        // Удаляем из ожидающих замен
        const newPendingReplacements = new Map(state.pendingReplacements);
        newPendingReplacements.delete(data.messageData.messageId);

        return {
          ...state,
          messages: [finalMessage, ...state.messages],
          pendingReplacements: newPendingReplacements,
        };
      }

      const newThinkingMessage = {
        messageData: {
          messageId: data.messageData.messageId,
          content: data.messageData.content || '🤔 Думаю...',
          createdAt: data.messageData.timestamp || new Date().toISOString(),
          chatId: data.chatId,
          isThinking: true,
          isBot: true,
        },
        userData: {
          firstName: data.messageData.botName || 'Бот',
          lastName: '',
          localPhotoUuid: null,
        },
      };

      console.log('✅ Adding new thinking message:', newThinkingMessage);

      return {
        ...state,
        messages: [newThinkingMessage, ...state.messages], // Prepend thinking message to show as new (top in column-reverse)
      };

    case REPLACE_THINKING_MESSAGE:
      console.log('🔄 REPLACE_THINKING_MESSAGE reducer called with data:', data);

      // Строгая валидация входных данных
      if (!data || !data.oldMessageId || !data.newMessage) {
        console.error('❌ Invalid replace data structure:', data);
        return state;
      }

      // Поиск thinking сообщения более надежным способом
      const messageIndex = state.messages.findIndex(msg => {
        const isMatchingId = msg.messageData.messageId === data.oldMessageId;
        const isThinkingMessage = msg.messageData.isThinking === true;
        return isMatchingId && isThinkingMessage;
      });

      console.log('🔍 Found thinking message at index:', messageIndex);
      console.log('🔍 Searching for oldMessageId:', data.oldMessageId);
      console.log('🔍 Total messages before replace:', state.messages.length);

      // Если thinking сообщение не найдено, сохраняем замену для последующего применения
      if (messageIndex === -1) {
        console.warn('⚠️ Thinking message not found, storing for later replacement:', data.oldMessageId);

        const newPendingReplacements = new Map(state.pendingReplacements || new Map());
        newPendingReplacements.set(data.oldMessageId, {
          newMessage: data.newMessage,
          timestamp: Date.now(),
        });

        return {
          ...state,
          pendingReplacements: newPendingReplacements,
        };
      }

      if (messageIndex !== -1) {
        const updatedMessages = [...state.messages];
        const oldMessage = state.messages[messageIndex];

        // Создаем новое сообщение, сохраняя структуру старого
        const replacedMessage = {
          messageData: {
            // Сохраняем важные поля из старого сообщения
            chatId: oldMessage.messageData.chatId,
            // Используем новые данные
            ...data.newMessage,
            // Убираем thinking флаги
            isThinking: false,
            isWaiting: false,
            isExtended: false,
            isTimeout: false,
            // Устанавливаем правильный messageId (используем новый, если есть)
            messageId: data.newMessage.messageId || data.oldMessageId,
            isBot: true,
            isError: data.newMessage.isError || false,
            createdAt: data.newMessage.timestamp || data.newMessage.createdAt || new Date().toISOString(),
          },
          userData: {
            firstName: data.newMessage.botName || oldMessage.userData?.firstName || 'Бот',
            lastName: oldMessage.userData?.lastName || '',
            localPhotoUuid: oldMessage.userData?.localPhotoUuid || null,
          },
        };

        console.log('🔄 Replacing thinking message with:', replacedMessage);
        console.log('🔄 Old message was:', oldMessage);

        updatedMessages[messageIndex] = replacedMessage;

        return {
          ...state,
          messages: updatedMessages,
        };
      }

      // Если thinking сообщение не найдено, логируем ошибку и НЕ добавляем дубликат
      console.error('❌ Thinking message not found for replacement:', {
        oldMessageId: data.oldMessageId,
        availableMessages: state.messages.map(m => ({
          id: m.messageData.messageId,
          isThinking: m.messageData.isThinking,
        })),
      });

      // Возвращаем состояние без изменений вместо создания дубликата
      return state;

    case CLEAR_THINKING_MESSAGES:
      // Очищаем думающие сообщения для определенного чата или все
      return {
        ...state,
        messages: state.messages.filter(msg => {
          if (!msg.messageData.isThinking) return true;
          if (data.chatId) return msg.messageData.chatId !== data.chatId;
          return false;
        }),
      };

    case CLEANUP_PENDING_REPLACEMENTS:
      // Очищаем устаревшие ожидающие замены (старше 30 секунд)
      const now = Date.now();
      const timeout = 30000; // 30 секунд
      const cleanedReplacements = new Map();

      if (state.pendingReplacements) {
        for (const [messageId, replacement] of state.pendingReplacements.entries()) {
          if (now - replacement.timestamp < timeout) {
            cleanedReplacements.set(messageId, replacement);
          } else {
            console.log('🧹 Cleaning up expired pending replacement:', messageId);
          }
        }
      }

      return {
        ...state,
        pendingReplacements: cleanedReplacements,
      };

    // Token usage actions
    case GET_COMPANY_TOKEN_QUOTA_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenQuota: true },
        isError: { ...state.isError, getCompanyTokenQuota: false },
      };

    case GET_COMPANY_TOKEN_QUOTA_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenQuota: false },
        isError: { ...state.isError, getCompanyTokenQuota: false },
        tokenQuota: response,
      };

    case GET_COMPANY_TOKEN_QUOTA_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenQuota: false },
        isError: { ...state.isError, getCompanyTokenQuota: true },
      };

    case UPDATE_COMPANY_TOKEN_QUOTA:
      return {
        ...state,
        tokenQuota: data,
      };

    case GET_COMPANY_TOKEN_USAGE_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenUsage: true },
        isError: { ...state.isError, getCompanyTokenUsage: false },
      };

    case GET_COMPANY_TOKEN_USAGE_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenUsage: false },
        isError: { ...state.isError, getCompanyTokenUsage: false },
        tokenUsage: {
          items: response.items || response.data || [],
          pagination: {
            total: response.total || 0,
            page: response.page || 1,
            limit: response.limit || 20,
          },
        },
      };

    case GET_COMPANY_TOKEN_USAGE_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getCompanyTokenUsage: false },
        isError: { ...state.isError, getCompanyTokenUsage: true },
      };

    case PUSH_COMPANY_TOKEN_QUOTA_START:
      return {
        ...state,
        isLoading: { ...state.isLoading, pushCompanyTokenQuota: true },
        isError: { ...state.isError, pushCompanyTokenQuota: false },
      };

    case PUSH_COMPANY_TOKEN_QUOTA_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, pushCompanyTokenQuota: false },
        isError: { ...state.isError, pushCompanyTokenQuota: false },
      };

    case PUSH_COMPANY_TOKEN_QUOTA_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, pushCompanyTokenQuota: false },
        isError: { ...state.isError, pushCompanyTokenQuota: true },
      };

    case STOP_SWITCHING_LOADING:
      return {
        ...state,
        isSwitchingChat: false,
      };

    default:
      return state;
  }
};
